import { Injectable } from '@angular/core';
import { Api } from '../providers/api/api';
import { Grupo } from '../entities/grupo';

@Injectable()
export class GrupoDAO {

    constructor(private _api: Api) { }

    public obterGruposDaEmpresa(idEmpresa: number): Promise<Grupo[]> {
        return new Promise((resolve, reject) => {
            let grupos: Grupo[] = [];

            this._api.get(`Grupo/${idEmpresa}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    grupos.push(new Grupo().deserialize(element));
                });
                
                resolve(grupos);
            }, error => {
                reject(error);
            });
        });
    }

    public obterGruposDaEmpresaPerfil(idEmpresa: number,perfil: string): Promise<Grupo[]> {
        return new Promise((resolve, reject) => {
            let grupos: Grupo[] = [];

            this._api.get(`Grupo/${idEmpresa}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    if ((perfil=='Gerente') || (new Grupo().deserialize(element).Id != 6)){
                        //console.log(new Grupo().deserialize(element).Id +'-'+ perfil);   
                        grupos.push(new Grupo().deserialize(element));   
                    }                                      
                    
                });

                resolve(grupos);
            }, error => {
                reject(error);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/daos/grupo-dao.ts